import { Component, OnInit, Input } from '@angular/core';
import { ComponentBase } from 'src/app/base/component-base';
import { CookiesLocalService } from 'src/app/service/cookies-local.service';
import { BehaviorModelChangeService } from 'src/app/service/behavior-model-change.service.service';

@Component({
  selector: 'app-site-layout',
  templateUrl: './site-layout.component.html',
  styleUrls: ['./site-layout.component.css']
})
export class SiteLayoutComponent  implements OnInit {
   isPostgraduateStudent:boolean;

public loginUserData:any={};
sideBarName='';
completionState:any;
  constructor(private cookieLocal:CookiesLocalService,private behaviorModelChangeService:BehaviorModelChangeService) { }
  

  ngOnInit() {
    let data=this.cookieLocal.getApplicantData();
    this.loginUserData=  data;
    // console.log(data);
    this.isPostgraduateStudent=
    this.loginUserData.ApplicationTypeId==7 || 
    this.loginUserData.ApplicationTypeId==8;

    this.behaviorModelChangeService.sideBar.subscribe(data=>{
      this.sideBarName=data;
    });

    this.behaviorModelChangeService.completionState.subscribe(data=>{
      this.completionState=data;
      // console.log(data);
    });
  }

}
